<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-09-03 14:35:40
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-03 15:44:43
 * @FilePath: \member_ship\src\views\introduce.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="MyintroduceBox">
    <div class="headerBox">商会介绍</div>
    <div class="mainBox">
      <div class="mainTitleBox">成都市三明商会</div>
      <div
        class="mainTextBox"
      >成都市三明商会成立于2025年，是由在蓉投资兴业的三明籍企业(锦幅海川(四川)企业管理有限公司，四川伊府客家餐饮管理有限公司，成都锦泰高德餐饮管理有限公司，成都展志商贸有限公司，四川悍森健身器材有限公司，成都绿光照明设备有限公司)六家企业自愿共同发起，经成都市民政局依法批准注册的非营利性社会团体法人，目前企业会员30家。成都市三明商会会长兼法人徐小平，锦福海川(四川)企业管理有限公司董事长。商会以“凝聚乡情、服务会员、共建平台、助力发展”为宗旨，致力于打造在蓉三明籍工商界人士的“家园”和连接成都与三明两地的经济文化桥梁。</div>
      <div class="mainTextBox2">一、商会核心使命</div>
      <div class="mainTextBox2">1、服务会员:维护会员合法权益，提供政策咨询、法律维权、融资对接、资源整合等服务，助力企业高质量发展。</div>
      <div class="mainTextBox2">2、促进合作:搭建政企沟通、行业交流、项目对接平台，推动会员间及成明两地经贸合作。</div>
      <div class="mainTextBox2">3、奉献社会:引导会员诚信经营、履行社会责任，积极参与公益事业，树立闽(明)商良好形象。</div>
      <div class="mainTextBox2">4、传承乡谊:组织联谊活动，增强在蓉三明人的凝聚力，弘扬闽商“敢拼会赢”精神。</div>
      <div class="mainTextBox2">二、会员构成</div>
      <div
        class="mainTextBox2"
      >会员水力怊織电力工程、商贸食品供应链、环保、钢贸、建筑、石材、照明及餐饮现代服务等领域的三明籍企业:家及企业代表，汇聚了一批具有影响力的优秀企业。</div>
      <div class="mainTextBox2">三、主要职能</div>
      <div class="mainTextBox2">
        1、政策与市场信息共享。2、商务考察与项目对接。3、法律财税专业支持。4、人才技术资源整合。5、政企沟:
        通协调。6、公益慈善活动组织。
      </div>
      <div class="mainTextBox2">四、组织架构</div>
      <div class="mainTextBox2">实行民主管理制度，设会员大会、理事会、监事会和秘书处，并设立专业委员会(青年委员会、法律顾问团)，确保高效运作。</div>
      <div class="mainTextBox2">五、愿景</div>
      <div class="mainTextBox2">建设成为“有凝聚力、有影响力、有社会责任感的标杆商会，为成明两地经济社会协同发展注入新动能。</div>
      <div class="mainTextBox2">六、办公地址</div>
      <div class="mainTextBox2">成都蛟龙港双流园区水口路12栋(209号)</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.MyintroduceBox {
  height: 100vh;
  width: 100vw;
  /* background-color: aqua; */
}
.headerBox {
  height: 80px;
  text-align: center;
  line-height: 80px;
  /* line-height: 50px; */
  /* background-color: #06bbe2; */
  background-image: url("../assets/OIP-C.jpg");
  color: white;
}
.mainBox {
  height: calc(100vh - 80px);
  width: 100%;
  overflow: auto;
  /* background-color: aqua; */
}
.mainTitleBox {
  height: 50px;
  width: 100%;
  /* background-color: aqua; */
  text-align: center;
  line-height: 50px;
}
.mainTextBox {
  font-size: 14px;
  padding: 0px 15px;
  text-indent: 2em;
  line-height: 20px;
}
.mainTextBox2 {
  font-size: 14px;
  padding: 0px 15px;
  text-indent: 2em;
  margin-top: 5px;
}
</style>